export default function Card({title, url, logo}){
	return <a className="card" href={url} target='_blank' >
		<img src={logo} width="25px"/>
		<h2>{title}</h2>
		<p></p>
	</a>
}